// Third party libraries
import * as $ from 'jquery';

export default {
	name: 'ModalNotificationBody',
	data() {
		return {
			modalContent: null
		}
	},
	beforeDestroy() {
		this.hideModal();
	},
	methods: {
		show(content) {
			this.modalContent = content;
			$(this.$refs.modalNotificationBody).modal('show');
		},
		hideModal() {
			$(this.$refs.modalNotificationBody).modal('hide');
		}
	}
}